export default __webpack_public_path__ + "assets/atalaia-component.2d513ca3.svg";